module.exports = __webpack_public_path__ + "img/logo_nitto.701f421e.png";